import { createClient } from '@supabase/supabase-js';

const projectURL = process.env.REACT_APP_SUPABASE_URL;
const projectKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseProjectId = process.env.REACT_APP_SUPABASE_PROJECT_ID;
export const supabase = createClient(projectURL, projectKey);

export const getToken = () => {
  const storageKey = `sb-${supabaseProjectId}-auth-token`;
  const sessionDataString = localStorage.getItem(storageKey);
  const sessionData = JSON.parse(sessionDataString || 'null');
  const token = sessionData?.access_token;

  return token;
};
